/* eslint-disable max-lines */
import { JPF_SESSION_INFO_KEY } from "../constants";

//////////////////////////////
/////////New events///////////
//////////////////////////////

//Web-only

export const ENHANCED_APPLY_CLICKED = {
  name: "ENHANCED_APPLY_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
};
export const JOB_POST_OPENED = {
  name: "JOB_POST_OPENED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE
export const JOB_POST_SUCCESS = {
  name: "JOB_POST_SUCCESS",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const AUTO_SAVE_JOB_POSTED = {
  name: "AUTO_SAVE_JOB_POSTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const JOB_POST_SUCCESS_NEW_USER = {
  name: "JOB_POST_SUCCESS_NEW_USER",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE
export const JOB_POST_EDIT = {
  name: "JOB_POST_EDIT",
  category: "UPDATE_JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE
export const CONTACT_DETAILS_SHOWN = {
  name: "CONTACT_DETAILS_SHOWN",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE
export const JOB_POST_COMPANY_DETAILS_SUCCESS = {
  name: "JOB_POST_COMPANY_DETAILS_SUCCESS",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE
export const JOB_POST_JD_VIEW = {
  name: "JOB_POST_JD_VIEW",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE
export const JOB_POST_OTHER_CITY_DRAWER_OPENED = {
  name: "JOB_POST_OTHER_CITY_DRAWER_OPENED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE
export const OTHER_CITY_OOPS_PAGE = {
  name: "OTHER_CITY_OOPS_PAGE",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE
export const UNDER_REVIEW_PAGE_OPENED = {
  name: "UNDER_REVIEW_PAGE_OPENED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE
export const JOB_POST_COMPLETED_SUCCESS_PAGE = {
  name: "JOB_POST_COMPLETED_SUCCESS_PAGE",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE
export const JOB_POST_VERIFICATION_INTIMATION_PAGE = {
  name: "JOB_POST_VERIFICATION_INTIMATION_PAGE",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE
export const JOB_POST_JD_UPLOAD_CLICK = {
  name: "JOB_POST_JD_UPLOAD_CLICK",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE
export const JOB_POST_VERIFY_DETAILS_CLICKED = {
  name: "JOB_POST_VERIFY_DETAILS_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const CLIENT_DETAILS_SHOWN = {
  name: "CLIENT_DETAILS_SHOWN",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

//Login
export const OTP_VERIFICATION_SUCCESS = {
  name: "OTP_VERIFICATION_SUCCESS",
  category: "Login"
}; //DONE
export const LOGIN_PHONE_NUMBER_ENTERED = {
  name: "LOGIN_PHONE_NUMBER_ENTERED",
  category: "Login"
}; //DONE

export const LOGIN_NEXT_CLICKED = {
  name: "LOGIN_NEXT_CLICKED",
  category: "Login"
}; //DONE

export const RECRUITER_LOGIN_PAGE_SHOWN = {
  name: "RECRUITER_LOGIN_PAGE_SHOWN",
  category: "Login"
}; //DONE

export const VERIFIED_SCREEN_SHOWN = {
  name: "VERIFIED_SCREEN_SHOWN",
  category: "Login"
}; //DONE

export const NEW_RECRUITER_LOGIN_SHOWN = {
  name: "NEW_RECRUITER_LOGIN_SHOWN",
  category: "NEW_LOGIN"
};

export const OLD_RECRUITER_LOGIN_SHOWN = {
  name: "OLD_RECRUITER_LOGIN_SHOWN",
  category: "Login"
};

export const NEW_RECRUITER_PUBLIC_LOGIN_SEEKER_CLICKED = {
  name: "NEW_RECRUITER_PUBLIC_LOGIN_SEEKER_CLICKED",
  category: "NEW_LOGIN"
};

export const NEW_RECRUITER_PUBLIC_LOGIN_RECRUITER_CLICKED = {
  name: "NEW_RECRUITER_PUBLIC_LOGIN_RECRUITER_CLICKED",
  category: "NEW_LOGIN"
};

export const NEW_RECRUITER_LOGIN_PHONE_NUMBER_ENTERED = {
  name: "NEW_RECRUITER_LOGIN_PHONE_NUMBER_ENTERED",
  category: "NEW_LOGIN"
};

export const LOGIN_OTP_RESEND = { name: "LOGIN_OTP_RESEND", category: "LOGIN" };

// Job

export const JOB_POST_FIRST_PAGE = {
  name: "JOB_POST_FIRST_PAGE",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
};
export const JOB_POST_SECOND_PAGE = {
  name: "JOB_POST_SECOND_PAGE",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
};
export const JOB_POST_THIRD_PAGE = {
  name: "JOB_POST_THIRD_PAGE",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
};
export const JOB_POST_FORTH_PAGE = {
  name: "JOB_POST_FORTH_PAGE",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
};
export const RECRUITER_PROFILE_CREATE = {
  name: "RECRUITER_PROFILE_CREATE",
  category: "PROFILE"
}; //DONE
export const UPDATE_JOB_FIRST_PAGE = {
  name: "UPDATE_JOB_FIRST_PAGE",
  category: "JOB"
};
export const UPDATE_JOB_SECOND_PAGE = {
  name: "UPDATE_JOB_SECOND_PAGE",
  category: "JOB"
};

// ProfileUpdate

export const PROFILE_BASIC_DETAILS = {
  name: "PROFILE_BASIC_DETAILS",
  category: "ProfileUpdate"
};
export const PROFILE_PERSONAL_DETAILS = {
  name: "PROFILE_PERSONAL_DETAILS",
  category: "ProfileUpdate"
};
export const PROFILE_COMPANY_PERKS = {
  name: "PROFILE_COMPANY_PERKS",
  category: "ProfileUpdate"
};

// NA or Miss
// export const APP_INSTALL = { name: "APP_INSTALL", category: "LOGIN" };
// export const APP_INSTALL_REFERRER = {
//   name: "APP_INSTALL_REFERRER",
//   category: "LOGIN"
// };
// export const KNOW_MORE = { name: "KNOW_MORE", category: "LOGIN" };
// export const APP_NOTIFICATION = { name: "APP_NOTIFICATION", category: "LOGIN" };
// export const LOGIN_BY = { name: "LOGIN_BY", category: "Login" };
// export const SESSION_OF_DAY = { name: "SESSION_OF_DAY", category: "Session" };

//////////////////////////////
/////////Old events///////////
//////////////////////////////

// CANDIDATE_ACTION

export const ACTION_OPEN_RESUME = {
  name: "ACTION_OPEN_RESUME",
  category: "CANDIDATE_ACTION"
}; //DONE
export const ACTION_REPORTED = {
  name: "ACTION_REPORTED",
  category: "CANDIDATE_ACTION"
}; //Not in Used, Need to Remove
export const ACTION_CANDIDATE_CALLED = {
  name: "ACTION_CANDIDATE_CALLED",
  category: "CANDIDATE_ACTION"
}; //DONE
export const ACTION_INVITE_FOR_INTERVIEW = {
  name: "ACTION_INVITE_FOR_INTERVIEW",
  category: "CANDIDATE_ACTION"
}; //DONE
export const ACTION_CANDIDATE_REJECT = {
  name: "ACTION_CANDIDATE_REJECT",
  category: "CANDIDATE_ACTION"
}; //DONE
export const HR_CALLBACK_REQUESTED_CLICKED = {
  name: "HR_CALLBACK_REQUESTED_CLICKED",
  category: "CANDIDATE_ACTION"
}; //DONE
export const VIEW_CANDIDATE_PROFILE = {
  name: "VIEW_CANDIDATE_PROFILE",
  category: "CANDIDATE_ACTION"
}; // Not in Used, Need to Remove
export const ACTION_TAB_CLICK = {
  name: "ACTION_TAB_CLICK",
  category: "CANDIDATE_ACTION"
}; // Not in Used, Need to Remove

export const ACTION_CALL_FEEDBACK = {
  name: "ACTION_CALL_FEEDBACK",
  category: "CANDIDATE_ACTION"
}; // Not in Used, Need to Remove

export const ACTION_IRRELEVANT_CANDIDATE = {
  name: "ACTION_IRRELEVANT_CANDIDATE",
  category: "CANDIDATE_ACTION"
}; //DONE

export const VIEW_IRRELEVANT_CANDIDATE = {
  name: "VIEW_IRRELEVANT_CANDIDATE",
  category: "CANDIDATE_ACTION"
}; //DONE

export const RESUME_CALL_CLICKED = {
  name: "RESUME_CALL_CLICKED",
  category: "CANDIDATE_ACTION"
}; //
export const RESUME_REMOVED_CLICKED = {
  name: "RESUME_REMOVED_CLICKED",
  category: "CANDIDATE_ACTION"
}; //
export const RESUME_INVITE_CLICKED = {
  name: "RESUME_INVITE_CLICKED",
  category: "CANDIDATE_ACTION"
}; //

export const IRRELEVANT_CANDIDATE_IMPRESSION = {
  name: "IRRELEVANT_CANDIDATE_IMPRESSION",
  category: "CANDIDATE_ACTION"
}; // Done

export const CANDIDATE_IMPRESSION = {
  name: "CANDIDATE_IMPRESSION",
  category: "CANDIDATE_ACTION"
}; // Done

export const ACTION_DOWNLOAD_RESUME = {
  name: "ACTION_DOWNLOAD_RESUME",
  category: "CANDIDATE_ACTION"
}; // //Not in Used, Need to Remove

export const CMP_PAGE_SHOWN = {
  name: "CMP_PAGE_SHOWN",
  category: "CANDIDATE_ACTION"
}; // Done

export const CMP_BUCKET_CLICKED = {
  name: "CMP_BUCKET_CLICKED",
  category: "CANDIDATE_ACTION"
}; // Done
export const CMP_TAB_CLICKED = {
  name: "CMP_TAB_CLICKED",
  category: "CANDIDATE_ACTION"
}; // Done

export const CMP_BUCKET_SHOWN = {
  name: "CMP_BUCKET_SHOWN",
  category: "CANDIDATE_ACTION"
}; // Done

export const CANDIDATE_FEEDBACK_SHOWN = {
  name: "CANDIDATE_FEEDBACK_SHOWN",
  category: "CANDIDATE_ACTION"
}; // Done

export const CANDIDATE_FEEDBACK_SUBMIT = {
  name: "CANDIDATE_FEEDBACK_SUBMIT",
  category: "CANDIDATE_ACTION"
}; // Done

export const CMP_BELLY_FILTERS_SHOWN = {
  name: "CMP_BELLY_FILTERS_SHOWN",
  category: "CANDIDATE_ACTION"
}; // Done

export const CMP_FILTER_SHOWN = {
  name: "CMP_FILTER_SHOWN",
  category: "CANDIDATE_ACTION"
}; // Done

export const CMP_FILTER_CLICKED = {
  name: "CMP_FILTER_CLICKED",
  category: "CANDIDATE_ACTION"
}; // Done

export const CMP_BELLY_FILTER_CLICKED = {
  name: "CMP_BELLY_FILTER_CLICKED",
  category: "CANDIDATE_ACTION"
}; // Done

export const CMP_REVIEW_CANDIDATE_CLICKED = {
  name: "CMP_REVIEW_CANDIDATE_CLICKED",
  category: "CANDIDATE_ACTION"
}; // Done

export const CMP_FIRST_INFO_SHOWN = {
  name: "CMP_FIRST_INFO_SHOWN",
  category: "CANDIDATE_ACTION"
}; // Done

export const CMP_SECOND_INFO_SHOWN = {
  name: "CMP_SECOND_INFO_SHOWN",
  category: "CANDIDATE_ACTION"
}; // Done

// Onboarding chnages

export const UNDER_REVIEW_VIEW_ALL_CANDIDATE_CLICKED = {
  name: "UNDER_REVIEW_VIEW_ALL_CANDIDATE_CLICKED",
  category: "CANDIDATE_ACTION"
}; // Done

export const UNDER_REVIEW_CMP_PAGE_SHOWN = {
  name: "UNDER_REVIEW_CMP_PAGE_SHOWN",
  category: "CANDIDATE_ACTION"
}; // Done

export const UNDER_REVIEW_CMP_FILTER_SHOWN = {
  name: "UNDER_REVIEW_CMP_FILTER_SHOWN",
  category: "CANDIDATE_ACTION"
}; // Done

export const UNDER_REVIEW_CMP_CANDIDATE_IMPRESSION = {
  name: "UNDER_REVIEW_CMP_CANDIDATE_IMPRESSION",
  category: "CANDIDATE_ACTION"
}; // Done

export const UNDER_REVIEW_CMP_CANDIDATE_ON_CALL_INVITED_CLICKED = {
  name: "UNDER_REVIEW_CMP_CANDIDATE_ON_CALL_INVITED_CLICKED",
  category: "CANDIDATE_ACTION"
}; //Done

export const UNDER_REVIEW_CMP_INFO_BOTTOMSHEET_SHOWN = {
  name: "UNDER_REVIEW_CMP_INFO_BOTTOMSHEET_SHOWN",
  category: "CANDIDATE_ACTION"
}; // Done

export const UNDER_REVIEW_CMP_INFO_BOTTOM_VERIFY_CLICKED = {
  name: "UNDER_REVIEW_CMP_INFO_BOTTOM_VERIFY_CLICKED",
  category: "CANDIDATE_ACTION"
}; // Done

export const UNDER_REVIEW_CMP_BELLY_VERIFY_CARD_CTA_CLICKED = {
  name: "UNDER_REVIEW_CMP_BELLY_VERIFY_CARD_CTA_CLICKED",
  category: "CANDIDATE_ACTION"
}; // Done

export const UNDER_REVIEW_CMP_VERIFY_DIALOG_SHOWN = {
  name: "UNDER_REVIEW_CMP_VERIFY_DIALOG_SHOWN",
  category: "CANDIDATE_ACTION"
}; // Done

export const UNDER_REVIEW_CMP_VERIFY_DIALOG_DOCUMENT_VERIFICATION_CLICKED = {
  name: "UNDER_REVIEW_CMP_VERIFY_DIALOG_DOCUMENT_VERIFICATION_CLICKED",
  category: "CANDIDATE_ACTION"
}; // Done

//Login

export const LOGIN_POST_JOB_CLICKED = {
  name: "LOGIN_POST_JOB_CLICKED",
  category: "Login"
};
export const OTP_SENT_SUCCESS = { name: "OTP_SENT_SUCCESS", category: "Login" }; //DONE
export const USER_LOGIN_COMPLETE = {
  name: "USER_LOGIN_COMPLETE",
  category: "Login"
};
export const INVALID_OTP = { name: "INVALID_OTP", category: "Login" }; //DONE

export const IS_RETURNING_USER = {
  name: "IS_RETURNING_USER",
  category: "CATEGORY_LOGIN"
}; //DONE

export const FIRST_TIME_USER = {
  name: "FIRST_TIME_USER",
  category: "CATEGORY_LOGIN"
}; //DONE

export const RETURNING_TIME_USER = {
  name: "RETURNING_TIME_USER",
  category: "CATEGORY_LOGIN"
}; //DONE

export const RECRUITER_PUBLIC_LOGIN_RECRUITER_CLICKED = {
  name: "RECRUITER_PUBLIC_LOGIN_RECRUITER_CLICKED",
  category: "Login"
}; //DONE

export const RECRUITER_PUBLIC_LOGIN_SEEKER_CLICKED = {
  name: "RECRUITER_PUBLIC_LOGIN_SEEKER_CLICKED",
  category: "Login"
}; //DONE

// Miss

// export const SHARE_APP = { name: "SHARE_APP", category: "LOGIN" };
// export const ERROR = { name: "ERROR", category: "LOGIN" };
// export const SIGN_OUT = { name: "SIGN_OUT", category: "LOGIN" };

// JOB EVENTS STARTS

export const ACTION_SEARCH_TITLE = {
  name: "ACTION_SEARCH_TITLE",
  category: "TitleSearch"
};

/* Events for job post add/edit */
export const POST_PAGEONE_UPLOAD_JD_CLICKED = {
  name: "POST_PAGEONE_UPLOAD_JD_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGEONE_UPLOAD_JD_SELECTED = {
  name: "POST_PAGEONE_UPLOAD_JD_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGEONE_UPLOAD_JD_NOT_SELECTED = {
  name: "POST_PAGEONE_UPLOAD_JD_NOT_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGEONE_TITLE_BOX_CLICKED = {
  name: "POST_PAGEONE_TITLE_BOX_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGEONE_TITLE_SUGGESTION_SELECTED = {
  name: "POST_PAGEONE_TITLE_SUGGESTION_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGEONE_CATEGORY_CLICKED = {
  name: "POST_PAGEONE_CATEGORY_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGEONE_CATEGORY_SELECTED = {
  name: "POST_PAGEONE_CATEGORY_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGEONE_NO_OF_OPENING_ENTERED = {
  name: "POST_PAGEONE_NO_OF_OPENING_ENTERED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGEONE_CITY_SELECTED = {
  name: "POST_PAGEONE_CITY_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGEONE_OTHER_CITY_CLICKED = {
  name: "POST_PAGEONE_OTHER_CITY_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE  replaced with JOB_POST_OTHER_CITY_DRAWER_OPENED

export const POST_PAGEONE_LOCALITY_CLICKED = {
  name: "POST_PAGEONE_LOCALITY_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGEONE_LOCALITY_SELECTED = {
  name: "POST_PAGEONE_LOCALITY_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGEONE_GENDER_SELECTED = {
  name: "POST_PAGEONE_GENDER_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGETWO_JOB_SHIFT_SELECTED = {
  name: "POST_PAGETWO_JOB_SHIFT_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGEONE_QUALIFICATION_SELECTED = {
  name: "POST_PAGEONE_QUALIFICATION_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGEONE_NEXT_CLICKED = {
  name: "POST_PAGEONE_NEXT_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Not Applicable

export const POST_PAGEONE_UPDATE_NEXT_CLICKED = {
  name: "POST_PAGEONE_UPDATE_NEXT_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Not Applicable

export const POST_PAGEONE_ADD_NEW_TITLE_CLICKED = {
  name: "POST_PAGEONE_ADD_NEW_TITLE_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Not Applicable

export const POST_PAGEONE_NOT_FINDING_JOB_TITLE_CLICKED = {
  name: "POST_PAGEONE_NOT_FINDING_JOB_TITLE_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Not Applicable

export const POST_PAGETWO_MIN_EXP_SELECTED = {
  name: "POST_PAGETWO_MIN_EXP_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGETWO_MAX_EXP_SELECTED = {
  name: "POST_PAGETWO_MAX_EXP_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGETWO_IS_FRESHER = {
  name: "POST_PAGETWO_IS_FRESHER",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGETWO_MIN_SAL_ENTERED = {
  name: "POST_PAGETWO_MIN_SAL_ENTERED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGETWO_MAX_SAL_ENTERED = {
  name: "POST_PAGETWO_MAX_SAL_ENTERED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGETWO_IS_INCENTIVES_EXTRA = {
  name: "POST_PAGETWO_IS_INCENTIVES_EXTRA",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGETWO_INCENTIVE_ENTERED = {
  name: "POST_PAGETWO_INCENTIVE_ENTERED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGETWO_SKILLS_SELECTED = {
  name: "POST_PAGETWO_SKILLS_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGETWO_SUGGESTED_JD_SELECTED = {
  name: "POST_PAGETWO_SUGGESTED_JD_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGETWO_JD_ENTERED = {
  name: "POST_PAGETWO_JD_ENTERED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGETWO_JOB_TYPE_TIMING_CHANGED_CLICKED = {
  name: "POST_PAGETWO_JOB_TYPE_TIMING_CHANGED_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const POST_PAGETWO_JOB_TYPE_SELECTED = {
  name: "POST_PAGETWO_JOB_TYPE_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const POST_PAGETWO_START_TIME_CLICKED = {
  name: "POST_PAGETWO_START_TIME_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; /// Done

export const POST_PAGETWO_START_TIME_SELECTED = {
  name: "POST_PAGETWO_START_TIME_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const POST_PAGETWO_END_TIME_SELECTED = {
  name: "POST_PAGETWO_END_TIME_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const POST_PAGETWO_END_TIME_CLICKED = {
  name: "POST_PAGETWO_END_TIME_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const POST_PAGETWO_WORKING_DAYS_SELECTED = {
  name: "POST_PAGETWO_WORKING_DAYS_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const POST_PAGETWO_PERKS_SELECTED = {
  name: "POST_PAGETWO_PERKS_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const POST_PAGETWO_OTHER_PERKS_ENTERED = {
  name: "POST_PAGETWO_OTHER_PERKS_ENTERED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const POST_PAGETWO_OTHER_SKILLS_ENTERED = {
  name: "POST_PAGETWO_OTHER_SKILLS_ENTERED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
};

export const POST_PAGETWO_OTHER_WORKING_DAYS_ENTERED = {
  name: "POST_PAGETWO_OTHER_WORKING_DAYS_ENTERED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
};

export const POST_PAGETWO_OTHER_INDUSTRY_ENTERED = {
  name: "POST_PAGETWO_OTHER_INDUSTRY_ENTERED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
};

export const POST_PAGEONE_DELIVERY_TYPES_SELECTED = {
  name: "POST_PAGEONE_DELIVERY_TYPES_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const POST_PAGETWO_REGIONAL_LANGUAGES_SELECTED = {
  name: "POST_PAGETWO_REGIONAL_LANGUAGES_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const POST_PAGETWO_WALKIN_CHECKED = {
  name: "POST_PAGETWO_WALKIN_CHECKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const POST_PAGETWO_ENGLISH_FLUENCY_SELECTED = {
  name: "POST_PAGETWO_ENGLISH_FLUENCY_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGETWO_ASSET_SELECTED = {
  name: "POST_PAGETWO_ASSET_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; //DONE

export const POST_PAGETWO_NEXT_CLICKED = {
  name: "POST_PAGETWO_NEXT_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Not Applicable

export const POST_PAGETWO_UPDATE_CLICKED = {
  name: "POST_PAGETWO_UPDATE_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Not Applicable

export const POST_PAGEONE_IS_WFH = {
  name: "POST_PAGEONE_IS_WFH",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // DONE

export const POST_PAGEONE_IS_CONTRACT = {
  name: "POST_PAGEONE_IS_CONTRACT",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // DONE

export const POST_POLICY_ACCEPTED = {
  name: "POST_POLICY_ACCEPTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // DONE

export const POST_PAGEONE_INDUSTRY_CLICKED = {
  name: "POST_PAGEONE_INDUSTRY_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
};

export const POST_PAGEONE_INDUSTRY_SELECTED = {
  name: "POST_PAGEONE_INDUSTRY_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
};

export const POST_PAGEONE_REQUIRED_INDUSTRY_CTA = {
  name: "POST_PAGEONE_REQUIRED_INDUSTRY_CTA",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
};

export const POST_PAGEONE_SALES_TYPE_SELECTED = {
  name: "POST_PAGEONE_SALES_TYPE_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
};

export const POST_PAGEONE_SALES_TYPE_EXPERIENCE_SELECTED = {
  name: "POST_PAGEONE_SALES_TYPE_EXPERIENCE_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
};

export const POST_PAGETWO_ADD_ENGLISH_CTA = {
  name: "POST_PAGETWO_ADD_ENGLISH_CTA",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
};

export const POST_PAGEONE_VIEW_OTHER_CITIES_CLICKED = {
  name: "POST_PAGEONE_VIEW_OTHER_CITIES_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
};

// JOB EVENTS ENDS

export const VERIFY_YOURSELF_VERIFY_DETAILS_CLICKED = {
  name: "VERIFY_YOURSELF_VERIFY_DETAILS_CLICKED",
  category: "Login"
};

export const VERIFY_YOURSELF_VERIFY_CALL_CLICKED = {
  name: "VERIFY_YOURSELF_VERIFY_CALL_CLICKED",
  category: "Login"
}; //Not Applicable

export const VERIFY_YOURSELF_GOTO_HOME_CLICKED = {
  name: "VERIFY_YOURSELF_GOTO_HOME_CLICKED",
  category: "Login"
};

export const CONTACT_DETAILS_FULL_NAME_ENTERED = {
  name: "CONTACT_DETAILS_FULL_NAME_ENTERED",
  category: "JOB"
}; // Done

export const CONTACT_DETAILS_EMAIL_ENTERED = {
  name: "CONTACT_DETAILS_EMAIL_ENTERED",
  category: "JOB"
}; // Done

export const CONTACT_DETAILS_COMPANY_NAME_ENTERED = {
  name: "CONTACT_DETAILS_COMPANY_NAME_ENTERED",
  category: "JOB"
}; // Done

export const CONTACT_DETAILS_COMPANY_ADDRESS = {
  name: "CONTACT_DETAILS_COMPANY_ADDRESS",
  category: "JOB"
}; // Done

export const CONTACT_DETAILS_SAVE_DETAILS_CLICKED = {
  name: "CONTACT_DETAILS_SAVE_DETAILS_CLICKED",
  category: "JOB"
}; //

export const CONTACT_DETAILS_CLIENT_NAME_ENTERED = {
  name: "CONTACT_DETAILS_CLIENT_NAME_ENTERED",
  category: "JOB"
}; //

export const POST_PAGETWO_JOB_CONTACT_ALLOW_CLICKED = {
  name: "POST_PAGETWO_JOB_CONTACT_ALLOW_CLICKED",
  category: "JOB"
}; // Done

export const POST_PAGETWO_JOB_CONTACT_EDIT = {
  name: "POST_PAGETWO_JOB_CONTACT_EDIT",
  category: "JOB"
}; // Done

export const POST_PAGETWO_JOB_CONTACT_ENTERED = {
  name: "POST_PAGETWO_JOB_CONTACT_ENTERED",
  category: "JOB"
}; // Done

export const POST_PAGETWO_WHATSAPP_ENABLE_CLICKED = {
  name: "POST_PAGETWO_WHATSAPP_ENABLE_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const POST_PAGETWO_WHATSAPP_EDIT = {
  name: "POST_PAGETWO_WHATSAPP_EDIT",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const POST_PAGETWO_WHATSAPP_ENTERED = {
  name: "POST_PAGETWO_WHATSAPP_ENTERED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const CONTACT_DETAILS_INTERVIEW_DIFFER = {
  name: "CONTACT_DETAILS_INTERVIEW_DIFFER",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const POST_PAGETWO_INTERVIEW_ADDRESS_ENTERED = {
  name: "POST_PAGETWO_INTERVIEW_ADDRESS_ENTERED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const POST_PAGETWO_INTERVIEW_ADDRESS_EDIT_CLICKED = {
  name: "POST_PAGETWO_INTERVIEW_ADDRESS_EDIT_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const CLIENT_DETAILS_INTERVIEW_ADDRESS = {
  name: "CLIENT_DETAILS_INTERVIEW_ADDRESS",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const CONTACT_DETAILS_CLIENT_INTERVIEW_ADDRESS = {
  name: "CONTACT_DETAILS_CLIENT_INTERVIEW_ADDRESS",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const CONTACT_DETAILS_IS_CONSULTANT = {
  name: "CONTACT_DETAILS_IS_CONSULTANT",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const CLIENT_DETAILS_CLIENT_NAME_ENTERED = {
  name: "CLIENT_DETAILS_CLIENT_NAME_ENTERED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const CLIENT_DETAILS_SAVE_DETAILS_CLICKED = {
  name: "CLIENT_DETAILS_SAVE_DETAILS_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const CONTACT_DETAILS_CITY_SELECTED = {
  name: "CONTACT_DETAILS_CITY_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const CONTACT_DETAILS_LOCALITY_CLICKED = {
  name: "CONTACT_DETAILS_LOCALITY_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const CONTACT_DETAILS_LOCALITY_SELECTED = {
  name: "CONTACT_DETAILS_LOCALITY_SELECTED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const CONTACT_DETAILS_INTERVIEW_ADDRESS = {
  name: "CONTACT_DETAILS_INTERVIEW_ADDRESS",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const IS_ADDITIONAL_FEE = {
  name: "IS_ADDITIONAL_FEE",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const POST_PAGETWO_AMOUNT_ENTERED = {
  name: "POST_PAGETWO_AMOUNT_ENTERED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const POST_PAGETWO_REASON_ENTERED = {
  name: "POST_PAGETWO_REASON_ENTERED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
}; // Done

export const JOB_TITLE_RESTRICTED_MODAL_OPEN = {
  name: "JOB_TITLE_RESTRICTED_MODAL_OPEN",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
};
export const JOB_TITLE_RESTRICTED_MODAL_DISMISS = {
  name: "JOB_TITLE_RESTRICTED_MODAL_DISMISS",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
};
export const JOB_TITLE_RESTRICTED_MODAL_GOT_IT_CLICK = {
  name: "JOB_TITLE_RESTRICTED_MODAL_GOT_IT_CLICK",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
};
export const POST_PAGETWO_JOB_CONTACT_VERIFY_CLICKED = {
  name: "POST_PAGETWO_JOB_CONTACT_VERIFY_CLICKED",
  category: "JOB",
  [JPF_SESSION_INFO_KEY]: true
};

export const VERIFY_MOBILE_OTP_SENT_SUCCESS = {
  name: "VERIFY_MOBILE_OTP_SENT_SUCCESS",
  category: "PHONE_VERIFICATION"
};

export const VERIFY_MOBILE_OTP_VERIFIED = {
  name: "VERIFY_MOBILE_OTP_VERIFIED",
  category: "PHONE_VERIFICATION"
};

export const VERIFY_MOBILE_RESEND_OTP = {
  name: "VERIFY_MOBILE_RESEND_OTP",
  category: "PHONE_VERIFICATION"
};

/* End events for job post add/edit */

/* Start events for Home Page */

export const PUBLIC_USER_LANDED = {
  name: "PUBLIC_USER_LANDED",
  category: "PUBLIC"
}; // Done

export const PUBLIC_CAROUSAL_CATEGORY_CLICKED = {
  name: "PUBLIC_CAROUSAL_CATEGORY_CLICKED",
  category: "PUBLIC"
}; // Done

export const PUBLIC_POST_JOB = {
  name: "PUBLIC_POST_JOB",
  category: "PUBLIC"
}; // Done

export const PUBLIC_WA_CLICKED = {
  name: "PUBLIC_WA_CLICKED",
  category: "PUBLIC"
}; // Done

export const PUBLIC_START_HIRING_STAFF = {
  name: "PUBLIC_START_HIRING_STAFF",
  category: "PUBLIC"
}; // Done

export const PUBLIC_CATEGORY_CLICKED = {
  name: "PUBLIC_CATEGORY_CLICKED",
  category: "PUBLIC"
}; // Done

export const PUBLIC_START_POSTING_JOB = {
  name: "PUBLIC_START_POSTING_JOB",
  category: "PUBLIC"
}; // Done

export const PUBLIC_EMAIL_CLICKED = {
  name: "PUBLIC_EMAIL_CLICKED",
  category: "PUBLIC"
}; // Done

export const PUBLIC_HEADER_DOWNLOAD_APP_CLICKED = {
  name: "PUBLIC_HEADER_DOWNLOAD_APP_CLICKED",
  category: "PUBLIC"
}; // Done

export const PUBLIC_HEADER_DOWNLOAD_APP_SUBMIT = {
  name: "PUBLIC_HEADER_DOWNLOAD_APP_SUBMIT",
  category: "PUBLIC"
}; // Done

export const PUBLIC_HEADER_FEEDBACK_CLICKED = {
  name: "PUBLIC_HEADER_FEEDBACK_CLICKED",
  category: "PUBLIC"
}; // Done

export const PUBLIC_HEADER_FEEDBACK_SUBMIT = {
  name: "PUBLIC_HEADER_FEEDBACK_SUBMIT",
  category: "PUBLIC"
}; // Done

export const PUBLIC_HEADER_LOGIN_CLICKED = {
  name: "PUBLIC_HEADER_LOGIN_CLICKED",
  category: "PUBLIC"
}; // Done

export const PUBLIC_HEADER_LOOKING_FOR_JOB = {
  name: "PUBLIC_HEADER_LOOKING_FOR_JOB",
  category: "PUBLIC"
}; // Done

export const PUBLIC_HB_CLICKED = {
  name: "PUBLIC_HB_CLICKED",
  category: "PUBLIC"
}; // Done

export const PUBLIC_HB_LOGIN_CLICKED = {
  name: "PUBLIC_HB_LOGIN_CLICKED",
  category: "PUBLIC"
}; // Done

export const PUBLIC_HB_DOWNLOAD_APP = {
  name: "PUBLIC_HB_DOWNLOAD_APP",
  category: "PUBLIC"
}; // Done

export const PUBLIC_HB_FEEDBACK_CLICKED = {
  name: "PUBLIC_HB_FEEDBACK_CLICKED",
  category: "PUBLIC"
}; // Done

export const PUBLIC_HB_LOOKING_FOR_JOB = {
  name: "PUBLIC_HB_LOOKING_FOR_JOB",
  category: "PUBLIC"
}; // Done

export const PUBLIC_FOOTER_ABOUT = {
  name: "PUBLIC_FOOTER_ABOUT",
  category: "PUBLIC"
}; // Done

export const PUBLIC_FOOTER_SEEKER_LOGIN = {
  name: "PUBLIC_FOOTER_SEEKER_LOGIN",
  category: "PUBLIC"
}; // Done

export const PUBLIC_FOOTER_COOKIE_POLICY = {
  name: "PUBLIC_FOOTER_COOKIE_POLICY",
  category: "PUBLIC"
}; // Done

export const PUBLIC_FOOTER_CONTACT_US = {
  name: "PUBLIC_FOOTER_CONTACT_US",
  category: "PUBLIC"
}; // Done

export const PUBLIC_FOOTER_PRIVACY_POLICY = {
  name: "PUBLIC_FOOTER_PRIVACY_POLICY",
  category: "PUBLIC"
}; // Done

export const PUBLIC_FOOTER_TERMS = {
  name: "PUBLIC_FOOTER_TERMS",
  category: "PUBLIC"
}; // Done

export const PUBLIC_FOOTER_FB = {
  name: "PUBLIC_FOOTER_FB",
  category: "PUBLIC"
}; // Done

export const PUBLIC_FOOTER_INSTAGRAM = {
  name: "PUBLIC_FOOTER_INSTAGRAM",
  category: "PUBLIC"
}; // Done

export const PUBLIC_FOOTER_TWITTER = {
  name: "PUBLIC_FOOTER_TWITTER",
  category: "PUBLIC"
}; // Done

export const RECRUITER_PUBLIC_SEEKER_CLICKED = {
  name: "RECRUITER_PUBLIC_SEEKER_CLICKED",
  category: "PUBLIC"
}; // Done

/* End events for Home Page */

/* Start Email Verification Events  */
export const HOME_EMAIL_VERIFICATION = {
  name: "HOME_EMAIL_VERIFICATION",
  category: "EMAIL_VERIFICATION"
}; //Done

export const CONTACT_DETAILS_EMAIL_VERIFICATION = {
  name: "CONTACT_DETAILS_EMAIL_VERIFICATION",
  category: "PROFILE_CREATION"
}; //Done

export const EMAIL_VERIFY_RESENT_EMAIL_CLICKED = {
  name: "EMAIL_VERIFY_RESENT_EMAIL_CLICKED",
  category: "EMAIL_VERIFICATION"
}; //Done

export const EMAIL_VERIFY_RESENT_EMAIL = {
  name: "EMAIL_VERIFY_RESENT_EMAIL",
  category: "EMAIL_VERIFICATION"
}; //Done

export const EMAIL_VERIFY_CHANGE_CLICKED = {
  name: "EMAIL_VERIFY_CHANGE_CLICKED",
  category: "EMAIL_VERIFICATION"
}; //Done

export const EMAIL_VERIFY_CHECK_LATER_CLICKED = {
  name: "EMAIL_VERIFY_CHECK_LATER_CLICKED",
  category: "EMAIL_VERIFICATION"
}; //Done

export const UPDATED_EMAIL_SAVED = {
  name: "UPDATED_EMAIL_SAVED",
  category: "EMAIL_VERIFICATION"
}; //Done

export const EMAIL_VERIFY_SUCCESS = {
  name: "EMAIL_VERIFY_SUCCESS",
  category: "EMAIL_VERIFICATION"
}; //Done

export const EMAIL_VERIFY_SHOWN = {
  name: "EMAIL_VERIFY_SHOWN",
  category: "EMAIL_VERIFICATION"
};

export const PROFILE_ON_EMAIL_VERIFY_CLICKED = {
  name: "PROFILE_ON_EMAIL_VERIFY_CLICKED",
  category: "EMAIL_VERIFICATION"
};

/* End Email Verification Events */
/* Start events for Filters */

export const CANDIDATE_IS_THIS_INFO_HELPFUL = {
  name: "CANDIDATE_IS_THIS_INFO_HELPFUL",
  category: "Filter"
}; // Done

export const FILTER_SALARY_SELECTED = {
  name: "FILTER_SALARY_SELECTED",
  category: "Filter"
}; // Done

export const FILTER_DISTANCE_SELECTED = {
  name: "FILTER_DISTANCE_SELECTED",
  category: "Filter"
}; // Done

export const FILTER_APPLIED = {
  name: "FILTER_APPLIED",
  category: "Filter"
}; // Done

export const FILTER_EXP_SELECTED = {
  name: "FILTER_EXP_SELECTED",
  category: "Filter"
}; // Done

export const FILTER_GENDER_SELECTED = {
  name: "FILTER_GENDER_SELECTED",
  category: "Filter"
}; // Done

export const FILTER_RESUME_SELECTED = {
  name: "FILTER_RESUME_SELECTED",
  category: "Filter"
}; // Done

export const FILTER_SKILL_SELECTED = {
  name: "FILTER_SKILL_SELECTED",
  category: "Filter"
}; // Done

/* End events for Filters */

/* Start JobFair Events */

export const BANNER_SHOW = {
  name: "BANNER_SHOW",
  category: "banner"
}; // Done

export const BANNER_CLICKED = {
  name: "BANNER_CLICKED",
  category: "banner"
}; // Done

/* End JobFair Events */

/* start Event for NPS */

export const NPS_SHOWN = {
  name: "NPS_SHOWN",
  category: "net_promoter_score"
};

export const NPS_USER_CLOSED = {
  name: "NPS_USER_CLOSED",
  category: "net_promoter_score"
};

export const NPS_SCORE_CLICKED = {
  name: "NPS_SCORE_CLICKED",
  category: "net_promoter_score"
};

export const NPS_SUBMITTED = {
  name: "NPS_SUBMITTED",
  category: "net_promoter_score"
};

/* End Event for NPS */

/* start Event for Dashboard */

export const DASHBOARD_SHOWN = {
  name: "DASHBOARD_SHOWN",
  category: "DASHBOARD"
};

export const DASHBOARD_TAB_CLICKED = {
  name: "DASHBOARD_TAB_CLICKED",
  category: "DASHBOARD"
};

export const DASHBOARD_MENU_CLICKED = {
  name: "DASHBOARD_MENU_CLICKED",
  category: "DASHBOARD"
};

export const EDIT_JOB_CLICKED = {
  name: "EDIT_JOB_CLICKED",
  category: "DASHBOARD"
};

export const CLOSE_JOB_CLICKED = {
  name: "CLOSE_JOB_CLICKED",
  category: "DASHBOARD"
};

export const VIEW_FILE_CLICKED = {
  name: "VIEW_FILE_CLICKED",
  category: "DASHBOARD"
};

export const VIEW_ALL_CANDIDATES = {
  name: "VIEW_ALL_CANDIDATES",
  category: "DASHBOARD"
};

export const DASHBOARD_JOB_UNACTIONED_CLICKED = {
  name: "DASHBOARD_JOB_UNACTIONED_CLICKED",
  category: "DASHBOARD"
};

export const DASHBOARD_JOB_ACTIONED_CLICKED = {
  name: "DASHBOARD_JOB_ACTIONED_CLICKED",
  category: "DASHBOARD"
};

export const GET_DOWNLOAD_APP_LINK = {
  name: "GET_DOWNLOAD_APP_LINK",
  category: "DASHBOARD"
};

export const DASHBOARD_VOLUNTARY_CLOSE_JOB_SHOWN = {
  name: "DASHBOARD_VOLUNTARY_CLOSE_JOB_SHOWN",
  category: "DASHBOARD"
};

export const DASHBOARD_VOLUNTARY_CLOSE_JOB_CLOSED = {
  name: "DASHBOARD_VOLUNTARY_CLOSE_JOB_CLOSED",
  category: "DASHBOARD"
};

export const DASHBOARD_VOLUNTARY_CLOSE_JOB_STILL_HIRING = {
  name: "DASHBOARD_VOLUNTARY_CLOSE_JOB_STILL_HIRING",
  category: "DASHBOARD"
};

export const MANUAL_JOB_CLOSE = {
  name: "MANUAL_JOB_CLOSE",
  category: "CLOSE_JOB"
};

export const BOTTOM_LINK_CALL_CLICKED = {
  name: "BOTTOM_LINK_CALL_CLICKED",
  category: "CLOSE_JOB"
};

export const DASHBOARD_JOB_SHARE_CLICKED = {
  name: "DASHBOARD_JOB_SHARE_CLICKED",
  category: "DASHBOARD"
};

export const DASHBOARD_ACCOUNT_VERIFY_CLICKED = {
  name: "DASHBOARD_ACCOUNT_VERIFY_CLICKED",
  category: "DASHBOARD"
}; // Done

export const REPOST_JOB_CLICKED = {
  name: "REPOST_JOB_CLICKED",
  category: "DASHBOARD"
};

/* End Event for Dashboard */
/* start Event for FAQ */

export const FAQ_SHOWN = {
  name: "FAQ_SHOWN",
  category: "Faq"
};

export const FAQ_CATEGORY_CLICK = {
  name: "FAQ_CATEGORY_CLICK",
  category: "Faq"
};

export const FAQ_QUESTION_CLICK = {
  name: "FAQ_QUESTION_CLICK",
  category: "Faq"
};

export const FAQ_CLICKED = {
  name: "FAQ_CLICKED",
  category: "Faq"
};

/* End Event for FAQ */

/* Start  home page event */

export const GET_HOME_APP_LINK = {
  name: "GET_HOME_APP_LINK",
  category: "PUBLIC"
};

export const PUBLIC_START_HIRING_HOW_TO_HIRE = {
  name: "PUBLIC_START_HIRING_HOW_TO_HIRE",
  category: "PUBLIC"
};

export const PUBLIC_START_HIRING_BANNER = {
  name: "PUBLIC_START_HIRING_BANNER",
  category: "PUBLIC"
};

export const PUBLIC_POST_A_JOB_NOW = {
  name: "PUBLIC_POST_A_JOB_NOW",
  category: "PUBLIC"
};

export const PUBLIC_DOWNLOAD_APP = {
  name: "PUBLIC_DOWNLOAD_APP",
  category: "PUBLIC"
};

export const HOME_CATEGORY_CLICKED = {
  name: "HOME_CATEGORY_CLICKED",
  category: "PUBLIC"
};

export const SHOW_ALL_CATEGORIES_CLICKED = {
  name: "SHOW_ALL_CATEGORIES_CLICKED",
  category: "PUBLIC"
};

export const HOME_SEE_ALL_FAQ_CLICKED = {
  name: "HOME_SEE_ALL_FAQ_CLICKED",
  category: "PUBLIC"
};

export const HOME_FAQ_CLICKED = {
  name: "HOME_FAQ_CLICKED",
  category: "PUBLIC"
};

/* End home page event */

/* Start referral event */

export const NPS_REFERRAL_SHOWN = {
  name: "NPS_REFERRAL_SHOWN",
  category: "REFERRAL"
};

export const NPS_REFERRAL_CLOSE = {
  name: "NPS_REFERRAL_CLOSE",
  category: "REFERRAL"
};

export const NPS_REFERRAL_CLICKED = {
  name: "NPS_REFERRAL_CLICKED",
  category: "REFERRAL"
};

export const CLOSE_JOB_REFERRAL_CLICKED = {
  name: "CLOSE_JOB_REFERRAL_CLICKED",
  category: "REFERRAL"
};

export const CLOSE_JOB_REFERRAL_SHOWN = {
  name: "CLOSE_JOB_REFERRAL_SHOWN",
  category: "REFERRAL"
};

export const CLOSE_JOB_REFERRAL_CLOSE = {
  name: "CLOSE_JOB_REFERRAL_CLOSE",
  category: "REFERRAL"
};

export const OTHER_CITY_REFERRAL_CLICKED = {
  name: "OTHER_CITY_REFERRAL_CLICKED",
  category: "REFERRAL"
};

export const CMP_REFERRAL_SHOWN = {
  name: "CMP_REFERRAL_SHOWN",
  category: "REFERRAL"
};

export const DASHBOARD_REFERRAL_SHOWN = {
  name: "DASHBOARD_REFERRAL_SHOWN",
  category: "REFERRAL"
};

export const PROFIE_REFERRAL_SHOWN = {
  name: "PROFIE_REFERRAL_SHOWN",
  category: "REFERRAL"
};
export const PROFILE_REFERRAL_CLICKED = {
  name: "PROFILE_REFERRAL_CLICKED",
  category: "REFERRAL"
};

export const DASHBOARD_REFERRAL_CLICKED = {
  name: "DASHBOARD_REFERRAL_CLICKED",
  category: "REFERRAL"
};

export const CMP_REFERRAL_CLICKED = {
  name: "CMP_REFERRAL_CLICKED",
  category: "REFERRAL"
};

/* End referral event */

/* DOC_VERIFICATION referral start */

export const DOC_VERIFICATION_UPLOAD_CLICKED = {
  name: "DOC_VERIFICATION_UPLOAD_CLICKED",
  category: "DOC_VERIFICATION"
};

export const DOC_VERIFICATION_UPLOAD_SUCCESS = {
  name: "DOC_VERIFICATION_UPLOAD_SUCCESS",
  category: "DOC_VERIFICATION"
};

export const DOC_VERIFICATION_CLEAR_CLICKED = {
  name: "DOC_VERIFICATION_CLEAR_CLICKED",
  category: "DOC_VERIFICATION"
};

export const DOC_VERIFICATION_CHANGE_DOCUMENT_CLICKED = {
  name: "DOC_VERIFICATION_CHANGE_DOCUMENT_CLICKED",
  category: "DOC_VERIFICATION"
};

export const DOC_VERIFICATION_CANCEL_CLICKED = {
  name: "DOC_VERIFICATION_CANCEL_CLICKED",
  category: "DOC_VERIFICATION"
};

export const DOC_VERIFICATION_VIEWER_OPENED = {
  name: "DOC_VERIFICATION_VIEWER_OPENED",
  category: "DOC_VERIFICATION"
};

export const DOC_VIEWER_CHANGE_DOCUMENT_CLICKED = {
  name: "DOC_VIEWER_CHANGE_DOCUMENT_CLICKED",
  category: "DOC_VERIFICATION"
};

export const DOC_VERIFICATION_VERIFY_ACCOUNT_CLICKED = {
  name: "DOC_VERIFICATION_VERIFY_ACCOUNT_CLICKED",
  category: "DOC_VERIFICATION"
};

export const DOC_VERIFICATION_SAVE_CLICKED_PROFILE = {
  name: "DOC_VERIFICATION_SAVE_CLICKED_PROFILE",
  category: "DOC_VERIFICATION"
};

export const HEADER_VIEW_COMPANY_DOCUMENT_CLICKED = {
  name: "HEADER_VIEW_COMPANY_DOCUMENT_CLICKED",
  category: "DOC_VERIFICATION"
};

export const DOC_VERIFICATION_VERIFY_LATER_CLICKED = {
  name: "DOC_VERIFICATION_VERIFY_LATER_CLICKED",
  category: "DOC_VERIFICATION"
};

export const DOC_VERIFICATION_DOC_TYPE_SELECTED = {
  name: "DOC_VERIFICATION_DOC_TYPE_SELECTED",
  category: "DOC_VERIFICATION"
};

export const DOC_VERIFICATION_DOC_NUMBER_ENTERED = {
  name: "DOC_VERIFICATION_DOC_NUMBER_ENTERED",
  category: "DOC_VERIFICATION"
};

export const DOC_VERIFICATION_SHOWN = {
  name: "DOC_VERIFICATION_SHOWN",
  category: "DOC_VERIFICATION"
};

export const YTP_CLOSED = {
  name: "YTP_CLOSED",
  category: "DOC_VERIFICATION"
};

export const DV_VIDEO_CLICKED = {
  name: "DV_VIDEO_CLICKED",
  category: "DOC_VERIFICATION"
};

export const DV_PAGE_VERIFY_LATER_CLICKED = {
  name: "DV_PAGE_VERIFY_LATER_CLICKED",
  category: "DOC_VERIFICATION"
};

export const DV_BS_VERIFY_LATER_CLICKED = {
  name: "DV_BS_VERIFY_LATER_CLICKED",
  category: "DOC_VERIFICATION"
};

export const DV_BS_CLOSED = {
  name: "DV_BS_CLOSED",
  category: "DOC_VERIFICATION"
};

export const DV_BS_VERIFY_NOW_CLICKED = {
  name: "DV_BS_VERIFY_NOW_CLICKED",
  category: "DOC_VERIFICATION"
};

export const DV_VIEW_MORE_DOC = {
  name: "DV_VIEW_MORE_DOC",
  category: "DOC_VERIFICATION"
};

export const DVF_VIEW_MORE_CLICKED = {
  name: "DVF_VIEW_MORE_CLICKED",
  category: "DOC_VERIFICATION"
};

export const DVF_LT_VERIFY_LATER = {
  name: "DOC_VERIFICATION_VERIFY_LATER_CLICKED",
  category: "DOC_VERIFICATION"
};

/* DOC_VERIFICATION referral end */

export const PUBLIC_OTP_ALERT = {
  name: "PUBLIC_OTP_ALERT",
  category: "PUBLIC"
};

export const PUBLIC_DOWNLOAD_ALERT = {
  name: "PUBLIC_DOWNLOAD_ALERT",
  category: "PUBLIC"
};

export const DASHBOARD_WHATSAPP_CLICKED = {
  name: "DASHBOARD_WHATSAPP_CLICKED",
  category: "DASHBOARD"
};
/* APP_RATING Event starts */
export const RATE_US = {
  name: "RATE_US",
  category: "APP_RATING"
};

export const RATING_BAD_CLICKED = {
  name: "RATING_BAD_CLICKED",
  category: "APP_RATING"
};
export const RATING_SATISFACTORY_CLICKED = {
  name: "RATING_SATISFACTORY_CLICKED",
  category: "APP_RATING"
};
export const RATING_GREAT_CLICKED = {
  name: "RATING_GREAT_CLICKED",
  category: "APP_RATING"
};
export const RATING_CLOSED = {
  name: "RATING_CLOSED",
  category: "APP_RATING"
};
export const RATING_WRITE_US = {
  name: "RATING_WRITE_US",
  category: "APP_RATING"
};
export const RATING_FEEDBACK = {
  name: "RATING_FEEDBACK",
  category: "APP_RATING"
};

/* APP_RATING Event End */

// Profile events start

export const PROFILE_SHOWN = {
  name: "PROFILE_SHOWN",
  category: "PROFILE"
}; //DONE

export const PROFILE_BACK_CLICKED = {
  name: "PROFILE_BACK_CLICKED",
  category: "PROFILE"
}; //DONE

export const PROFILE_PERSONAL_DETAILS_EDIT_CLICKED = {
  name: "PROFILE_PERSONAL_DETAILS_EDIT_CLICKED",
  category: "PROFILE"
}; //DONE

export const PROFILE_COMPANY_DETAILS_EDIT_CLICKED = {
  name: "PROFILE_COMPANY_DETAILS_EDIT_CLICKED",
  category: "PROFILE"
}; //DONE

export const PROFILE_COMPANY_DOC_EDIT_CLICKED = {
  name: "PROFILE_COMPANY_DOC_EDIT_CLICKED",
  category: "PROFILE"
}; //DONE

export const PROFILE_COMPANY_DOC_VIEWER_CLICKED = {
  name: "PROFILE_COMPANY_DOC_VIEWER_CLICKED",
  category: "PROFILE"
}; //DONE

export const PERSONAL_DETAILS_SHOWN = {
  name: "PERSONAL_DETAILS_SHOWN",
  category: "PROFILE"
}; //DONE

export const PERSONAL_DETAILS_UPDATE_CLICKED = {
  name: "PERSONAL_DETAILS_UPDATE_CLICKED",
  category: "PROFILE"
}; //DONE

export const COMPANY_DETAILS_SHOWN = {
  name: "COMPANY_DETAILS_SHOWN",
  category: "PROFILE"
}; //DONE

export const COMPANY_DETAILS_UPDATE_CLICKED = {
  name: "COMPANY_DETAILS_UPDATE_CLICKED",
  category: "PROFILE"
}; //DONE

// export const COMPANY_DETAILS_LOGO_CLICKED = {
//   name: "COMPANY_DETAILS_LOGO_CLICKED",
//   category: "PROFILE"
// };

// export const NEED_HELP_CLICKED = {
//   name: "NEED_HELP_CLICKED",
//   category: "PROFILE"
// };

export const WHATSAPP_ENABLE_CLICKED = {
  name: "WHATSAPP_ENABLE_CLICKED",
  category: "PROFILE"
}; //DONE

// check

export const SIGN_OUT = {
  name: "SIGN_OUT",
  category: "PROFILE"
}; //DONE

export const SIGN_OUT_ALL_DEVICE = {
  name: "SIGN_OUT_ALL_DEVICE",
  category: "PROFILE"
}; //DONE

// export const SETTING_REFERRAL_CLICKED = {
//   name: "SETTING_REFERRAL_CLICKED",
//   category: "PROFILE"
// };

export const SETTINGS_DEACTIVATE_CONFIRM_SHOWN = {
  name: "SETTINGS_DEACTIVATE_CONFIRM_SHOWN",
  category: "PROFILE"
}; //deactivate account from footer //DONE

export const DEACTIVATE_CONFIRM_LOGOUT = {
  name: "DEACTIVATE_CONFIRM_LOGOUT",
  category: "PROFILE"
}; //logout //DONE

export const DEACTIVATE_CONFIRM_QUESTION_SHOWN = {
  name: "DEACTIVATE_CONFIRM_QUESTION_SHOWN",
  category: "PROFILE"
}; // checkboxes shown //DONE

export const DEACTIVATE_SHEET_SHOWN = {
  name: "DEACTIVATE_SHEET_SHOWN",
  category: "PROFILE"
}; //otp screen on next clicked //DONE

export const ACTION_DEACTIVATE = {
  name: "ACTION_DEACTIVATE",
  category: "PROFILE"
}; //main api deactivate success

// export const SHARE_APP = {
//   name: "SHARE_APP",
//   category: "PROFILE"
// };

// Profile events end

export const NEW_CITY_REC_BANNER_SHOWN = {
  name: "NEW_CITY_REC_BANNER_SHOWN",
  category: "NEW_CITY"
}; //DONE

export const NEW_CITY_REC_BANNER_CLOSE = {
  name: "NEW_CITY_REC_BANNER_CLOSE",
  category: "NEW_CITY"
}; //DONE

export const NEW_CITY_HIRE_STAFF_BUTTON = {
  name: "NEW_CITY_HIRE_STAFF_BUTTON",
  category: "NEW_CITY"
}; //DONE

export const DATABASE_MATCH_INFO_SHOWN = {
  name: "DATABASE_MATCH_INFO_SHOWN",
  category: "CANDIDATE_ACTION"
}; // Done

export const HOME_CITY_CLICKED = {
  name: "HOME_CITY_CLICKED",
  category: "HOME"
}; // Done

export const CMP_AUDIO_SHOWN = {
  name: "CMP_AUDIO_SHOWN",
  category: "CANDIDATE_ACTION"
};

export const CMP_AUDIO_PLAYED = {
  name: "CMP_AUDIO_PLAYED",
  category: "CANDIDATE_ACTION"
};

export const CMP_AUDIO_COMPLETE = {
  name: "CMP_AUDIO_COMPLETE",
  category: "CANDIDATE_ACTION"
};

export const CMP_AUDIO_INFO_SHOWN = {
  name: "CMP_AUDIO_INFO_SHOWN",
  category: "CANDIDATE_ACTION"
};

export const ACTION_CANDIDATE_MESSAGED = {
  name: "ACTION_CANDIDATE_MESSAGE",
  category: "CANDIDATE_ACTION"
};

export const EVENTS = {
  EMAIL_VERIFICATION: {
    VERIFY_EMAIL_SHOWN: {
      name: "EOTP_VERIFY_EMAIL_SHOWN",
      category: "EMAIL_VERIFICATION"
    },
    VERIFY_NOW_CLICKED: {
      name: "EOTP_NEXT_CLICKED",
      category: "EMAIL_VERIFICATION"
    },
    NO_OFFICIAL_ID: {
      name: "EOTP_NO_OFFICIAL_ID",
      category: "EMAIL_VERIFICATION"
    },
    OTP_SCREEN_SHOWN: {
      name: "EOTP_OTP_SCREEN_SHOWN",
      category: "EMAIL_VERIFICATION"
    },
    VERIFY_LATER_CTA: {
      name: "EOTP_VERIFY_LATER",
      category: "EMAIL_VERIFICATION"
    },
    OTP_NEXT_CTA: {
      name: "EOTP_OTP_VERIFY",
      category: "EMAIL_VERIFICATION"
    },
    ALTERNATE_OTP_NEXT_CTA: {
      name: "EOTP_ALTR_OTP_VERIFY",
      category: "EMAIL_VERIFICATION"
    },
    ALTERNATE_EMAIL_BOTTOM_SHEET: {
      name: "EOTP_ALTR_BS_SHOWN",
      category: "EMAIL_VERIFICATION"
    },
    ALTERNATE_OTP_BOTTOM_SHEET: {
      name: "EOTP_ALTR_OTP_BS_SHOWN",
      category: "EMAIL_VERIFICATION"
    },
    ALTERNATE_EMAIL_BOTTOM_VERIFY_CLCKD: {
      name: "EOTP_ALTR_BS_NEXT",
      category: "EMAIL_VERIFICATION"
    },
    EMAIL_ERROR: {
      name: "EOTP_ERROR",
      category: "EMAIL_VERIFICATION"
    },
    PERSONAL_EMAIL_BTM_SHOWN: {
      name: "EOTP_PERSONAL_EMAIL_BS_SHOWN",
      category: "EMAIL_VERIFICATION"
    },
    PERSONAL_EMAIL_BTM_EDIT: {
      name: "EOTP_BS_EDIT",
      category: "EMAIL_VERIFICATION"
    },
    PERSONAL_EMAIL_BTM_CLCKD: {
      name: "EOTP_PERSONAL_EMAIL_BS_CLICKED",
      category: "EMAIL_VERIFICATION"
    },
    EOTP_ALTR_BS_GMAIL_CLICKED: {
      name: "EOTP_ALTR_BS_GMAIL_CLICKED",
      category: "EMAIL_VERIFICATION"
    }
  },
  CMP_EVENTS: {
    CMP_SUB_TAB_CLICKED: {
      name: "CMP_SUB_TAB_CLICKED",
      category: "CANDIDATE_ACTION"
    },
    CMP_FILTER_FAB_CLICKED: {
      name: "CMP_FILTER_FAB_CLICKED",
      category: "CANDIDATE_ACTION"
    },
    JOB_CLOSE_CERTI: {
      name: "JOB_CLOSE_CERTI",
      category: "CANDIDATE_ACTION"
    },
    JOB_CLOSE_CMP: {
      name: "JOB_CLOSE_CMP",
      category: "CANDIDATE_ACTION"
    },
    DOWNLOAD_CERTIFICATE: {
      name: "DOWNLOAD_CERTIFICATE",
      category: "CANDIDATE_ACTION"
    },
    // DOWNLOAD_CERTI_POST_CLOSE: {
    //   name: "DOWNLOAD_CERTI_POST_CLOSE",
    //   category: "CANDIDATE_ACTION"
    // },
    VIEW_HIRED_CANDIDATES: {
      name: "VIEW_HIRED_CANDIDATES",
      category: "CANDIDATE_ACTION"
    },
    CLOSE_PAGE_DOWNLOAD_CERTI: {
      name: "CLOSE_CMP_DOWNLOAD_CERTI",
      category: "CANDIDATE_ACTION"
    }
  }
};

export const REC_WEB_SESSION_START = {
  name: "REC_WEB_SESSION_START",
  category: "MISCELLANEOUS"
};

export const DPR_VALUE = {
  name: "DPR_VALUE",
  category: "MISCELLANEOUS"
};

export const WHATSAPP_TRACKING = {
  name: "WHATSAPP_TRACKING",
  category: "MISCELLANEOUS"
};

export const JR_EVENTS = {
  JR_DUPLICATE_JOB_SHOWN: {
    name: "JR_DUPLICATE_JOB_SHOWN",
    category: "JOB_REFRESH"
  },
  JR_DUPLICATE_JOB_SUBMIT: {
    name: "JR_DUPLICATE_JOB_SUBMIT",
    category: "JOB_REFRESH"
  }
};

export const CALL_FEEDBACK_EVENTS = {
  CALL_FEEDBACK_DISMISS: {
    name: "CALL_FEEDBACK_DISMISS",
    category: "CANDIDATE_ACTION"
  },
  CALL_FEEDBACK_SHOWN: {
    name: "CALL_FEEDBACK_SHOWN",
    category: "CANDIDATE_ACTION"
  },
  CALL_FEEDBACK_SUBMIT: {
    name: "CALL_FEEDBACK_SUBMIT",
    category: "CANDIDATE_ACTION"
  }
};

export const MOENGAGE_USER = {
  name: "MOENGAGE_USER_REC",
  category: "MOENGAGE"
};

export const DASHBOARD_ARCHIVED_CLICK = {
  name: "DASHBOARD_ARCHIVED_CLICK",
  category: "DASHBOARD"
};
export const PREMIUM_INTENT = {
  PREMIUM_BANNER_SHOWN: {
    name: "PREMIUM_BANNER_SHOWN",
    category: "PREMIUM_INTENT"
  },
  PREMIUM_BANNER_CLICKED: {
    name: "PREMIUM_BANNER_CLICKED",
    category: "PREMIUM_INTENT"
  },
  PREMIUM_INTENT_CALL: {
    name: "PREMIUM_INTENT_CALL",
    category: "PREMIUM_INTENT"
  },
  PREMIUM_EMPTY_STATE_SHOWN: {
    name: "PREMIUM_EMPTY_STATE_SHOWN",
    category: "PREMIUM_INTENT"
  },
  BOOST_JOB_CLICKED: {
    name: "BOOST_JOB_CLICKED",
    category: "PREMIUM_INTENT"
  }
};

export const CAPTCHA_EVENTS = {
  CAPTCHA_SHOWN: {
    name: "CAPTCHA_SHOWN",
    category: "FRAUD_CAPTCHA"
  },
  CAPTCHA_SUCCESS: {
    name: "CAPTCHA_SUCCESS",
    category: "FRAUD_CAPTCHA"
  },
  CAPTCHA_FAILURE: {
    name: "CAPTCHA_FAILURE",
    category: "FRAUD_CAPTCHA"
  },
  CAPTCHA_SIGN_OUT: {
    name: "CAPTCHA_SIGN_OUT",
    category: "FRAUD_CAPTCHA"
  }
};

export const JOB_POSTING_LIMIT = {
  JOB_POSTING_BLOCKED_BANNER_SHOWN: {
    name: "JOB_POSTING_BLOCKED_BANNER_SHOWN",
    category: "JOB"
  },
  JOB_POSTING_BLOCKED_BANNER_DISMISSED: {
    name: "JOB_POSTING_BLOCKED_BANNER_DISMISSED",
    category: "JOB"
  },
  JOB_POSTING_BLOCKED_BANNER_CALL_CLICKED: {
    name: "JOB_POSTING_BLOCKED_BANNER_CALL_CLICKED",
    category: "JOB"
  },
  DASHBOARD_NEED_HELP_CLICKED: {
    name: "DASHBOARD_NEED_HELP_CLICKED",
    category: "DASHBOARD"
  },
  COHORT_LIMIT_SHOWN_ON_DASHBOARD: {
    name: "COHORT_LIMIT_SHOWN_ON_DASHBOARD",
    category: "DASHBOARD"
  },
  COHORT_LIMIT_CONTACT_SALES_CLICKED: {
    name: "COHORT_LIMIT_CONTACT_SALES_CLICKED",
    category: "DASHBOARD"
  }
};

export const FROM_REPOST_CAMPAIGN = {
  name: "FROM_REPOST_CAMPAIGN",
  category: "JOB"
};

export const HELP_CENTER_EVENTS = {
  HELP_CENTER_SHOWN: {
    name: "HELP_CENTER_SHOWN",
    category: "HELP_CENTER"
  },
  HELP_CENTER_ITEM_CLICKED: {
    name: "HELP_CENTER_ITEM_CLICKED",
    category: "HELP_CENTER"
  },
  HELP_CENTER_OPTION_CLICKED: {
    name: "HELP_CENTER_OPTION_CLICKED",
    category: "HELP_CENTER"
  },
  HELP_CENTER_FEEDBACK_SUBMIT: {
    name: "HELP_CENTER_FEEDBACK_SUBMIT",
    category: "HELP_CENTER"
  },
  HELP_CENTER_CALL_CLICKED: {
    name: "HELP_CENTER_CALL_CLICKED",
    category: "HELP_CENTER"
  },
  HELP_CENTER_COPY_CLICKED: {
    name: "HELP_CENTER_COPY_CLICKED",
    category: "HELP_CENTER"
  }
};

export const COMPANY_CLEANING_EVENTS = {
  COMPANY_NAME_BANNER_SHOWN: {
    name: "COMPANY_NAME_BANNER_SHOWN",
    category: "COMPANY_CLEANING"
  },
  COMPANY_NAME_BANNER_CLICKED: {
    name: "COMPANY_NAME_BANNER_CLICKED",
    category: "COMPANY_CLEANING"
  },
  COMPANY_NAME_BS_POPUP: {
    name: "COMPANY_NAME_BS_POPUP",
    category: "COMPANY_CLEANING"
  },
  COMPANY_NAME_CONFIRM_CLICKED: {
    name: "COMPANY_NAME_CONFIRM_CLICKED",
    category: "COMPANY_CLEANING"
  },
  COMPANY_NAME_UPDATE_CLICKED: {
    name: "COMPANY_NAME_UPDATE_CLICKED",
    category: "COMPANY_CLEANING"
  },
  COMPANY_NAME_BS_DISMISS: {
    name: "COMPANY_NAME_BS_DISMISS",
    category: "COMPANY_CLEANING"
  },
  CLIENT_NAME_SUGGESTION_SELECTED: {
    name: "CLIENT_NAME_SUGGESTION_SELECTED",
    category: "COMPANY_CLEANING"
  },
  COMPANY_MANUAL_ADD_CLICKED: {
    name: "COMPANY_MANUAL_ADD_CLICKED",
    category: "COMPANY_CLEANING"
  },
  COMPANY_NAME_BLUR_TO_CLEAR: {
    name: "COMPANY_NAME_BLUR_TO_CLEAR",
    category: "COMPANY_CLEANING"
  },
  UPLOAD_NEW_DOCUMENT_BS_SHOWN: {
    name: "UPLOAD_NEW_DOCUMENT_BS_SHOWN",
    category: "COMPANY_CLEANING"
  },
  ADD_NEW_DOCUMENT_CLICKED: {
    name: "ADD_NEW_DOCUMENT_CLICKED",
    category: "COMPANY_CLEANING"
  },
  UPLOAD_NEW_DOCUMENT_BS_DISMISS: {
    name: "UPLOAD_NEW_DOCUMENT_BS_DISMISS",
    category: "COMPANY_CLEANING"
  },
  IN_PROGRESS_CONFIRM_NOW_CLICK: {
    name: "IN_PROGRESS_CONFIRM_NOW_CLICK",
    category: "COMPANY_CLEANING"
  }
};

export const OWNER_EMPLOYEE_MAPPING_EVENTS = {
  OWNER_EMPLOYEE_POPUP_SHOWN: {
    name: "OWNER_EMPLOYEE_POPUP_SHOWN",
    category: "OWNER_EMPLOYEE_MAPPING"
  },
  OWNER_EMPLOYEE_POPUP_DISMISSED: {
    name: "OWNER_EMPLOYEE_POPUP_DISMISSED",
    category: "OWNER_EMPLOYEE_MAPPING"
  },
  OWNER_EMPLOYEE_ROLE_SELECTED: {
    name: "OWNER_EMPLOYEE_ROLE_SELECTED",
    category: "OWNER_EMPLOYEE_MAPPING"
  },
  OWNER_EMPLOYEE_FORM_SUBMITTED: {
    name: "OWNER_EMPLOYEE_FORM_SUBMITTED",
    category: "OWNER_EMPLOYEE_MAPPING"
  },
  OWNER_EMPLOYEE_NAME_FILLED: {
    name: "OWNER_EMPLOYEE_NAME_FILLED",
    category: "OWNER_EMPLOYEE_MAPPING"
  },
  OWNER_EMPLOYEE_EMAIL_FILLED: {
    name: "OWNER_EMPLOYEE_EMAIL_FILLED",
    category: "OWNER_EMPLOYEE_MAPPING"
  },
  OWNER_EMPLOYEE_PHONE_FILLED: {
    name: "OWNER_EMPLOYEE_PHONE_FILLED",
    category: "OWNER_EMPLOYEE_MAPPING"
  },
  OWNER_EMPLOYEE_SUCCESSFUL_CONVERSION: {
    name: "OWNER_EMPLOYEE_SUCCESSFUL_CONVERSION",
    category: "OWNER_EMPLOYEE_MAPPING"
  }
};

export const LEAD_GENERATION_EVENTS = {
  LEAD_GENERATION_LANDED: {
    name: "LEAD_GENERATION_LANDED",
    category: "LEAD_GENERATION"
  },
  LEAD_GEN_GET_A_CALLBACK_CLICK: {
    name: "LEAD_GEN_GET_A_CALLBACK_CLICK",
    category: "LEAD_GENERATION"
  },
  LEAD_GEN_VERIFY_OTP_CLICK: {
    name: "LEAD_GEN_VERIFY_OTP_CLICK",
    category: "LEAD_GENERATION"
  },
  LEAD_GEN_RECRUITER_DETAILS_SUBMIT: {
    name: "LEAD_GEN_RECRUITER_DETAILS_SUBMIT",
    category: "LEAD_GENERATION"
  },
  LEAD_GEN_MODAL_DISMISS: {
    name: "LEAD_GEN_MODAL_DISMISS",
    category: "LEAD_GENERATION"
  }
};

export const DATABASE_EVENTS = {
  DATABASE_CMP_CTA_CLICKED: {
    name: "DATABASE_CMP_CTA_CLICKED",
    category: "DATABASE_PRODUCT"
  }, //
  DATABASE_LANDED: {
    name: "DATABASE_LANDED",
    category: "DATABASE_PRODUCT"
  }, //
  DATABASE_GET_DATA: {
    name: "DATABASE_GET_DATA",
    category: "DATABASE_PRODUCT"
  }, //
  FILTER_APPLIED: {
    name: "FILTER_APPLIED",
    category: "DATABASE_PRODUCT"
  }, //
  RESET_APPLIED: {
    name: "RESET_APPLIED",
    category: "DATABASE_PRODUCT"
  }, //
  // JS_CARD_IMPRESSION: {
  //   name: "JS_CARD_IMPRESSION",
  //   category: "DATABASE_PRODUCT"
  // },
  UNLOCK_CLICKED: {
    name: "UNLOCK_CLICKED",
    category: "DATABASE_PRODUCT"
  }, //
  AUDIO_INTERVIEW_CLICKED: {
    name: "AUDIO_INTERVIEW_CLICKED",
    category: "DATABASE_PRODUCT"
  }, //
  KNOW_MORE_CLICKED: {
    name: "KNOW_MORE_CLICKED",
    category: "DATABASE_PRODUCT"
  }, //
  ALREADY_APPLIED_UNLOCK_POP_UP_SHOWN: {
    name: "ALREADY_APPLIED_UNLOCK_POP_UP_SHOWN",
    category: "DATABASE_PRODUCT"
  }, //
  ALREADY_APPLIED_UNLOCK_POP_UP_CONFIRM: {
    name: "ALREADY_APPLIED_UNLOCK_POP_UP_CONFIRM",
    category: "DATABASE_PRODUCT"
  }, //
  ALREADY_APPLIED_UNLOCK_POP_UP_DISMISS: {
    name: "ALREADY_APPLIED_UNLOCK_POP_UP_DISMISS",
    category: "DATABASE_PRODUCT"
  }, //
  // CONTACT_SALES_CLICKED_POP_UP_SHOWN: {
  //   name: "CONTACT_SALES_CLICKED_POP_UP_SHOWN",
  //   category: "DATABASE_PRODUCT"
  // },
  // CONTACT_SALES_CLICKED_POP_UP_DISMISS: {
  //   name: "CONTACT_SALES_CLICKED_POP_UP_DISMISS",
  //   category: "DATABASE_PRODUCT"
  // },
  SORT_CLICKED: {
    name: "SORT_CLICKED",
    category: "DATABASE_PRODUCT"
  }, //
  SORT_APPLIED: {
    name: "SORT_APPLIED",
    category: "DATABASE_PRODUCT"
  }, //
  // CANDIDATES_PER_PAGE_CLICKED: {
  //   name: "CANDIDATES_PER_PAGE_CLICKED",
  //   category: "DATABASE_PRODUCT"
  // },
  CANDIDATES_PER_PAGE_APPLIED: {
    name: "CANDIDATES_PER_PAGE_APPLIED",
    category: "DATABASE_PRODUCT"
  }, //
  NEXT_PAGE_CLICKED: {
    name: "NEXT_PAGE_CLICKED",
    category: "DATABASE_PRODUCT"
  }, //
  PREVIOUS_PAGE_CLICKED: {
    name: "PREVIOUS_PAGE_CLICKED",
    category: "DATABASE_PRODUCT"
  }, //
  DATABASE_BACK_CLICKED: {
    name: "DATABASE_BACK_CLICKED",
    category: "DATABASE_PRODUCT"
  }, //
  DATABASE_ALL_TAB_CLICKED: {
    name: "DATABASE_ALL_TAB_CLICKED",
    category: "DATABASE_PRODUCT"
  }, //
  DATABASE_UNLOCKED_TAB_CLICKED: {
    name: "DATABASE_UNLOCKED_TAB_CLICKED",
    category: "DATABASE_PRODUCT"
  }, //
  ACTION_MENU_CLICKED: {
    name: "ACTION_MENU_CLICKED",
    category: "DATABASE_PRODUCT"
  },
  // FILTER_CTA_CLICK: {
  //   name: "FILTER_CTA_CLICK",
  //   category: "DATABASE_PRODUCT"
  // },
  DATABASE_EDUCATION_POP_UP_SHOWN: {
    name: "DATABASE_EDUCATION_POP_UP_SHOWN",
    category: "DATABASE_PRODUCT"
  }, //
  DATABASE_EDUCATION_POP_UP_DISMISS: {
    name: "DATABASE_EDUCATION_POP_UP_DISMISS",
    category: "DATABASE_PRODUCT"
  }, //
  DATABASE_EDUCATION_POP_UP_NEXT_CLICKED: {
    name: "DATABASE_EDUCATION_POP_UP_NEXT_CLICKED",
    category: "DATABASE_PRODUCT"
  }, //
  DATABASE_EDUCATION_BANNER_SHOWN: {
    name: "DATABASE_EDUCATION_BANNER_SHOWN",
    category: "DATABASE_PRODUCT"
  }, //
  DB_TRY_NOW_CLICKED: {
    name: "DB_TRY_NOW_CLICKED",
    category: "DATABASE_PRODUCT"
  }, //
  DB_JOBS_MODAL_SHOWN: {
    name: "DB_JOBS_MODAL_SHOWN",
    category: "DATABASE_PRODUCT"
  }, //
  DB_MODAL_JOB_CLICK: {
    name: "DB_MODAL_JOB_CLICK",
    category: "DATABASE_PRODUCT"
  }, //
  DB_COACH_MARK_SHOWN: {
    name: "DB_COACH_MARK_SHOWN",
    category: "DATABASE_PRODUCT"
  }, //
  DB_COACH_MARK_DISMISS: {
    name: "DB_COACH_MARK_DISMISS",
    category: "DATABASE_PRODUCT"
  }, //
  DB_INACTIVITY_POP_UP_SHOWN: {
    name: "DB_INACTIVITY_POP_UP_SHOWN",
    category: "DATABASE_PRODUCT"
  }, //
  DB_INACTIVITY_POP_UP_EXPLORE_CLICKED: {
    name: "DB_INACTIVITY_POP_UP_EXPLORE_CLICKED",
    category: "DATABASE_PRODUCT"
  }, //
  DB_INACTIVITY_POP_UP_DISMISS: {
    name: "DB_INACTIVITY_POP_UP_DISMISS",
    category: "DATABASE_PRODUCT"
  }, //
  DB_EDUCATION_VIDEO_STARTED: {
    name: "DB_EDUCATION_VIDEO_STARTED",
    category: "DATABASE_PRODUCT"
  },
  DB_EDUCATION_VIDEO_ENDED: {
    name: "DB_EDUCATION_VIDEO_ENDED",
    category: "DATABASE_PRODUCT"
  },
  DB_EDUCATION_VIDEO_CLOSED: {
    name: "DB_EDUCATION_VIDEO_CLOSED",
    category: "DATABASE_PRODUCT"
  },
  DB_JOBS_BANNER_KNOW_MORE_CLICKED: {
    name: "DB_JOBS_BANNER_KNOW_MORE_CLICKED",
    category: "DATABASE_PRODUCT"
  },
  FREE_UNLOCKS_CONSUMED_POP_UP_SHOWN: {
    name: "FREE_UNLOCKS_CONSUMED_POP_UP_SHOWN",
    category: "DATABASE_PRODUCT"
  },
  FREE_UNLOCKS_CONSUMED_POP_UP_CONTACT_SALES_CLICKED: {
    name: "FREE_UNLOCKS_CONSUMED_POP_UP_CONTACT_SALES_CLICKED",
    category: "DATABASE_PRODUCT"
  },
  FREE_UNLOCKS_CONSUMED_POP_UP_DISMISS: {
    name: "FREE_UNLOCKS_CONSUMED_POP_UP_DISMISS",
    category: "DATABASE_PRODUCT"
  },
  BULK_UNLOCK_CLICKED: {
    name: "BULK_UNLOCK_CLICKED",
    category: "BULK_UNLOCK_CANDIDATES"
  }
  // CONTACT_SALES_CLICKED_POP_UP_SHOWN: {
  //   name: "CONTACT_SALES_CLICKED_POP_UP_SHOWN",
  //   category: "DATABASE_PRODUCT"
  // },
};
